import React from "react";
import { Route, Routes } from "react-router-dom";
import Navbar from "./Components/Navbar";
import About from "./Components/About";
import Footer from "./Components/Footer";
import Hero from "./Components/Hero";
import WelcomePage from "./Components/WelcomePage";
import Contact from "./Components/Contact";
import NewPatientss from "./Components/NewPatientss";
import Service from "./Components/Service";
import TermsOfUse from "./Components/Termsofuse";
import PrivacyPolicy from "./Components/PrivacyPolicy";
// === NEW IMPORT: Add the HowItWorksContent component ===
import HowItWorksContent from "./Components/HowItWorksContent";
import MainPage from "./Components/MainPage";
import "./App.css";

document.addEventListener('scroll', function () {
  const scrollUpButton = document.getElementById('scrollUpButton');
  if (scrollUpButton) {
    if (window.scrollY > 20) {
      scrollUpButton.classList.add('visible');
    } else {
      scrollUpButton.classList.remove('visible');
    }
  }
});

const App = () => {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/registration" element={<MainPage />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>

      <Footer />

      <a href="#" className="scroll-up" id="scrollUpButton">
        Scroll Up
      </a>
    </>
  );
};

export default App;